module.exports = __webpack_public_path__ + "img/telegram-white.196ba3dd.svg";